// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"912f5133","110":"cdf0a7ae","295":"0a85a85f","412":"28f42c3e","544":"6a961826","665":"b3bc614e"}[chunkId] + ".chunk.js";
};